var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mp-avatar',{attrs:{"size":_vm.size,"src":_vm.avatarUrl,"name":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }